import { render } from "./Result.vue?vue&type=template&id=17f670ba&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=17f670ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17f670ba"

export default script